import { IcoCheck16 } from '@onefootprint/icons';
import type { JSX } from 'react';
import Highlighter from 'react-highlight-words';
import type { CommonPropsAndClassName, GroupBase } from 'react-select';
import Text from '../../../../text';
import type { BaseSelectOption } from '../../base-select.types';

export type OptionProps<
  Option extends BaseSelectOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = CommonPropsAndClassName<Option, IsMulti, Group> & {
  innerProps: JSX.IntrinsicElements['div'];
  label: string;
  data: Option;
  isFocused: boolean;
  isSelected: boolean;
};

const Option = <Option extends BaseSelectOption, IsMulti extends boolean, Group extends GroupBase<Option>>({
  isSelected,
  selectProps,
  isFocused,
  innerProps,
  label,
  data,
}: OptionProps<Option, IsMulti, Group>) => {
  const { inputValue } = selectProps;

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: markup unchanged from the styled component this replaces
    // biome-ignore lint/a11y/useKeyWithMouseEvents: markup unchanged from the styled component this replaces
    <div
      className="fp-dropdown-item text-body-2 absolute top-0 left-0 w-full flex items-center justify-between py-2 px-4 cursor-pointer"
      data-highlighted={isFocused}
      id={innerProps.id}
      onClick={innerProps.onClick}
      onMouseMove={innerProps.onMouseMove}
      onMouseOver={innerProps.onMouseOver}
      // biome-ignore lint/a11y/useSemanticElements: TODO: change to <option />
      role="option"
      tabIndex={innerProps.tabIndex}
    >
      <div className="flex flex-col gap-0.5 items-start min-w-0 flex-1">
        <Highlighter
          className="block truncate w-full"
          searchWords={[inputValue]}
          textToHighlight={label}
          highlightStyle={{
            background: 'none',
            fontWeight: 600,
          }}
        >
          {label}
        </Highlighter>
        {data.description && (
          <Text variant="caption-2" color="tertiary">
            {data.description}
          </Text>
        )}
      </div>
      {isSelected && <IcoCheck16 color="primary" />}
    </div>
  );
};

export default Option;
